export default "__VITE_ASSET__vhiUJB1X__"